import { motion } from "framer-motion";
import { FOUNDER_MARKERS } from "@/data/content";

export const Founder = () => (
  <section data-testid="founder-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[80px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-16"
      >
        <div className="lg:col-span-4">
          <h2
            data-testid="founder-headline"
            className="font-heading text-[32px] font-semibold leading-tight text-ink sm:text-[38px] lg:text-[44px]"
          >
            Jun Zhu
          </h2>
          <p data-testid="founder-intro" className="mt-4 text-lg font-medium leading-relaxed text-ink lg:text-lg">
            More than 30 years of engineering, manufacturing, R&amp;D and executive-management
            experience.
          </p>
        </div>

        <div className="lg:col-span-8 lg:pt-1">
          <p data-testid="founder-body" className="text-[15px] leading-relaxed text-inkSoft">
            Jun Zhu's career spans engineering, manufacturing, OEM sourcing, industrial
            integration and executive management across China and North America. His
            experience in supplier qualification, procurement and technical coordination
            supports the delivery of integrated energy systems.
          </p>

          <div className="mt-8 grid grid-cols-1 divide-y divide-borderLight border-t border-borderLight sm:grid-cols-3 sm:divide-x sm:divide-y-0">
            {FOUNDER_MARKERS.map((marker, i) => (
              <div key={marker.stat} data-testid={`founder-marker-${i}`} className="py-5 sm:px-6 sm:py-0 sm:pt-6 first:sm:pl-0">
                <span className="block font-heading text-lg font-semibold text-ink">{marker.stat}</span>
                <span className="mt-1.5 block text-sm leading-relaxed text-inkMuted">{marker.label}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
